import { NavLink  } from 'react-router-dom';

export default function NavTimeline() {
  	return (
        <div className="nav-align-top">
            <ul className="nav nav-pills flex-column flex-md-row mb-6">
                <li className="nav-item">
                    <NavLink to="/timeline" className="nav-link">
                        <i className="bx me-1_5 bx-task bx-md"></i>
                        Attività
                    </NavLink>
                </li>
                <li className="nav-item">
                    <NavLink to="/activity-groups" className="nav-link">
                        <i className="bx bx-stats bx-md"></i>
                        Gruppi
                    </NavLink>
                </li>
            </ul>
        </div>
	);
}